const axios = require('axios');
async function getAllGrounds(condition) {
  try {
    const res = await axios.get('/api/v1/admin/ground/all', { params: condition });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function getGround(id) {
  try {
    const res = await axios.get('/api/v1/admin/ground', { params: { id } });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function updateGround(body) {
  try {
    const resData = await axios.put('/api/v1/admin/ground', body);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function uploadGroundImage(id, imageFile) {
  try {
    const data = new FormData();
    data.append('_id', id);
    data.append('image', imageFile);
    const resData = await axios.put('/api/v1/admin/ground/image', data);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { getAllGrounds, getGround, updateGround, uploadGroundImage };
